// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__18dHK","actionColumn":"ReferralSources_actionColumn__2YgNM","textButton":"ReferralSources_textButton__2Zh8-"};